import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function ClampitPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <div className="bg-[#f8f8f8] border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-2 text-sm">
          <h5 className="font-semibold text-[#333333]">CLAMPIT</h5>
          <h5 className="text-[#999999]">/</h5>
          <h5><Link to="/" className="text-[#14B8A6] hover:underline">Home</Link></h5>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - Images and Video */}
          <div>
            <div className="mb-6">
              <img 
                              src="/images/C688HC.jpg" 
                alt="Tree Clipper" 
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
            
            
          </div>

          {/* Right Column - Product Info */}
          <div>
            
            <h1 className="text-4xl font-bold text-[#333333] mb-4">CLAMPIT</h1>
            <h4 className="text-xl font-semibold text-[#666666] mb-2">Model: C68800</h4>
            <h4 className="text-xl font-semibold text-[#666666] mb-6">Weight: 164 lbs</h4>

            <div className="prose max-w-none mb-8">
              <h2 className="text-2xl font-bold text-[#333333] mb-4">Control The Fall of Trees & Protect Your Equipment!</h2>
              
              <p className="text-[#666666] mb-4">
                The CLAMPit is the newest addition to the lineup of HyReach Tree Shears. Now you can have control over the fall of cut trees and limbs. Simply CLAMP the tree or limb and then cut. After the cut, the CLAMPit will retain the tree or limb allowing you to neatly pile the brush for easy cleanup with a grapple rake or simply take the brush to a burn pile. The CLAMPit will reduce the risk of trees falling causing damage. The clamping is controlled from inside the cab with a wireless remote. If your equipment has electrical outlets, PIN connectors are available for most applications so you may use the buttons on your control handles. The CLAMPit can easily be added to existing HD and XD series tree shears. Load Limit is 200lbs. Check out our Log CLAMPit Capacity Chart below.
              </p>

              
              
            </div>

            {/* Features Accordion */}
            <div className="mb-8">
              <details className="group" open>
                <summary className="flex items-center justify-between cursor-pointer list-none p-4 bg-[#f8f8f8] rounded-lg font-bold text-[#333333]">
                  <span>FEATURES</span>
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="p-4 bg-white">
                  <ul className="list-disc list-inside space-y-2 text-[#666666]">
                    <li>Hardened T1 Clamping Blades</li>
                    <li>Greased Pivot Points</li>
                    <li>Backstop to prevent tree from falling back</li>
                    <li>Center Load Support on new models</li>
                    <li>Welded Clamping Cylinder</li>
                  </ul>
                </div>
              </details>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-4 mb-8">
              <a 
                href="/contact" 
                className="bg-[#14B8A6] text-white text-center px-8 py-3 font-bold hover:bg-[#0f9b8e] transition-colors whitespace-nowrap"
              >
                Call Us Now
              </a>
              
              
            </div>
          </div>
        </div>
      </div>

   

      {/* Disclaimer */}
      <div className="bg-white py-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h3 className="text-2xl font-bold text-[#333333] mb-4">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h3>
          <p className="text-[#666666]">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </p>
        </div>
      </div>

     
    </div>
  );
}
